<template>
	<ul class="key-value-list">
		<slot>

		</slot>
	</ul>
</template>

<script>
export default{
	name: 'key-value-list'
}
</script>

<style scoped>
.key-value-list{
	list-style: none;
	padding:0;
}
</style>
